













































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../requester';

import { UsuarioLoginFormData } from '../../../back/src/types';

import EsqueciMinhaSenhaModal from '../components/EsqueciMinhaSenhaModal.vue';

export default Vue.extend({
  name: 'Login',
  components: {
    EsqueciMinhaSenhaModal,
  },
  data() {
    return {
      loading: false,
      form: {
        email: '',
        senha: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        email: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const emailPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return (v && emailPattern.test(v)) || 'E-mail inválido';
          },
        ],
      },
    };
  },
  computed: {
    inputSenha(): Vue & { focus: () => void } {
      return this.$refs.inputSenha as Vue & { focus: () => void };
    },
    formLogin(): Vue & { validate: () => Boolean } {
      return this.$refs.formLogin as Vue & { validate: () => Boolean };
    },
    redirect() {
      return this.$route.query.redirect;
    },
    loggedOut() {
      return this.$route.query.loggedOut;
    },
  },
  mounted() {
    if (this.loggedOut) {
      this.$root.$emit('avisoSnackbar', { color: 'error', text: 'Você precisa entrar no sistema para acessar este conteúdo.' });
    }
  },
  methods: {
    async focusInputSenha() {
      if (this.form.senha !== '') {
        await this.submitFormDebounce();
      }
      this.inputSenha.focus();
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formLogin.validate()) {
        this.loading = false;
        return;
      }
      const formData: UsuarioLoginFormData = {
        email: this.form.email,
        senha: this.form.senha,
      };
      try {
        const response = await Requester.usuario.login(formData);
        if (response.errors.length === 0) {
          this.$store.dispatch('login', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Login realizado com sucesso.' });
          if (this.$store.getters.usuario && this.$store.getters.usuario.grupo.alias === 'pacientes') {
            this.$router.push({ name: 'MedicoesIndex' });
          } else {
            this.$router.push(this.redirect ? this.redirect : { name: 'Home' });
          }
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = true;
      }
    },
  },
});
